import { render, staticRenderFns } from "./BtnSolicitarPlano.vue?vue&type=template&id=639be3ec&"
import script from "./BtnSolicitarPlano.vue?vue&type=script&lang=js&"
export * from "./BtnSolicitarPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports